import { render } from "./ValidationFieldSet.vue?vue&type=template&id=49fcb121&scoped=true&ts=true"
import script from "./ValidationFieldSet.vue?vue&type=script&lang=ts"
export * from "./ValidationFieldSet.vue?vue&type=script&lang=ts"

import "./ValidationFieldSet.vue?vue&type=style&index=0&id=49fcb121&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49fcb121"]])

export default __exports__